import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProfileLayout = () => {
  const { t } = useTranslation('common');

  return (
    <div className="mx-auto min-h-[60vh] w-full max-w-7xl space-y-3 px-0 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] md:space-y-4 md:px-0 md:pb-12">
      <h1 className="sr-only">{t('profilePage.pageTitle', { defaultValue: 'Mon profil' })}</h1>
      <Outlet />
    </div>
  );
};

export default ProfileLayout;
